import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Vehiculo } from 'src/app/interfaces/vehiculo';
import { VehiculoService } from 'src/app/service/vehiculo.service';

@Component({
  selector: 'app-vehiculo-form',
  templateUrl: './vehiculo-form.component.html',
  styleUrls: ['./vehiculo-form.component.css']
})
export class VehiculoFormComponent implements OnInit {
  vehiculo:Vehiculo;
  constructor(private vehiculoService:VehiculoService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.vehiculo={marca: '',
    modelo:'',
    ano:2015,
    patente:'',
    detalle:'',
    estado:true
  };
  if(data.id>0){
    this.vehiculoService.getVehiculosById(data.id).toPromise().then((data:Vehiculo) => {
      this.vehiculo=data;
    });
  }


  }

  ngOnInit(): void {
  }

  async guardar(){
    if(this.vehiculo.id===undefined){

      await this.vehiculoService.postNuevo(this.vehiculo)
    }else{

      await this.vehiculoService.put(this.vehiculo)
    }
  }


}
